import RouteTemplate from 'ember-route-template'
import BaseRouteTemplate from 'customer-flows/templates/base-route-template'
import TwoColumn from 'customer-flows/components/layout-kit/two-column'
import StepContainer from 'customer-flows/components/flow-kit/step-container'
import ProgressBar from 'customer-flows/components/flow-kit/progress-bar'
import StaticFooter from 'customer-flows/components/booking/static-footer'
import SuccessImage from 'customer-flows/components/ui-kit/success-image'
import OrderSummary from 'customer-flows/components/booking/order-summary'
import t from 'ember-intl/helpers/t'
import { action } from '@ember/object'
import { context } from 'customer-flows/utils/core'
import { tracked } from '@glimmer/tracking'

const progressBarExcludedPages: PageType[] = ['FlowConfigBookingStartPage']

class BookingConfirmationTemplate extends BaseRouteTemplate<BookingConfirmationPage> {
  @tracked successImageAnimationDone = false

  @context('account') theme: AccountStore['theme']

  @action
  onTimeout() {
    this.successImageAnimationDone = true
  }

  <template>
    <div data-testid='booking-flow' class='mx-auto my-0 flex h-full w-full flex-col items-center'>
      <ProgressBar @excludePages={{progressBarExcludedPages}} @done={{true}} @showBackButton={{false}} />

      {{#unless this.successImageAnimationDone}}
        <div class='flex h-[600px] w-full items-center justify-center'>
          <SuccessImage @theme={{this.theme}} @onTimeout={{this.onTimeout}} />
        </div>
      {{/unless}}

      {{#if this.successImageAnimationDone}}
        <TwoColumn @stickyColumn='right'>
          <:leftColumn>
            <div class='flex flex-col gap-4'>
              <StepContainer />
            </div>
          </:leftColumn>

          <:rightColumn>
            <div data-testid='booking-flow__order-summary' class='hidden @md/flow:block'>
              <OrderSummary />
            </div>
          </:rightColumn>

          <:staticFooter>
            <StaticFooter @text={{t 'booking.footer.text' htmlSafe=true}} />
          </:staticFooter>
        </TwoColumn>
      {{/if}}
    </div>
  </template>
}

export default RouteTemplate(BookingConfirmationTemplate)
